<template>
  <div class="payment-methods-container"  style="border: solid 2px rgba(0, 0, 0, 0.1); padding: 25px">
    <strong>PayPal</strong>
    <div class="d-flex flex-column mb-2" style="margin-top: 15px">
      <t-checkbox
        v-model="transferInfo.agree1"
        name="agree"
        :label="$translation($websiteText().checkout_payment_method_waiting_for_availability_confirmation_checkbox)"
      />
    </div>
    <div class="d-flex mb-2" style="margin-top: 15px">
      <t-checkbox
        v-model="transferInfo.agree2"
        name="agree"
        :label="$translation($websiteText().checkout_payment_method_agree)"
      />
      
      <div class="terms" @click="goToTerms()">{{$translation($websiteText().checkout_payment_method_terms_of_use)}}</div>
    </div>
    <div class="paypal-submit-class">
      <t-button
        :disabled="!transferInfo.agree2 || !transferInfo.agree1 || !canPay"
        style="margin-left: auto; margin-top:10px;"
        :icon="'pi pi-credit-card'"
        :label="$translation($websiteText().checkout_payment_method_pay_by_paypal)"
        @click="submit()"
        :color="'primary-color'"
        :buttonClass="'paypal-submit-btn'"
      />
      &nbsp;
      <div class="paypal-bottom-info">
        <span  class="price-class">{{$store.getters.currency.symbol + amount}}</span>
        <span class="fees-class">{{$translation($websiteText().checkout_payment_method_paypal_fees)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import TButton from "../../../../../common/components/buttons/TButton.vue";
import { reactive } from "@vue/reactivity";
import { computed } from "@vue/runtime-core";

import TCheckbox from "../../../../../common/components/controls/TCheckbox.vue";
import GeneralVariables from "../../../../../common/utils/GeneralVariables";

import { defineAsyncComponent } from 'vue'
const InputMask = defineAsyncComponent(() =>
  import('primevue/inputmask')
)

export default {
  components: {
    TButton,
    TCheckbox,
  },

  setup(props) {
    let buttonMessageText = reactive({ value: props.buttonMessage });
    const amount = computed(()=>props.total);

    let cardDetail = reactive({
      num1: 4242,
      num2: 4242,
      num3: 4242,
      num4: 4242,
      name: "Haydar Nasreddine",
      cvc: 123,
      expMonth: 12,
      expYear: 22
    });

    let transferInfo = reactive({ agree1: false, agree2: false });
    return { transferInfo, cardDetail, buttonMessageText, amount };
  },

  data() {
    return {
      publishableKey: this.$store.getters.billingCompany.stripe_publishable_key||process.env.STRIPE_PUBLISHABLE_KEY,
      token: null,
      stripe: null,
      clientSecret: null,
    };
  },
  props: {
    buttonMessage: {
      default: "PAY BY PAYPAL",
    },
    total: Number,
    currency: String,
    paymentDoneAction: Function,
  },
  computed:
  {
    canPay()
    {
      return this.$store.getters.status_id == 1
    }
  },
  methods:{
    goToTerms(){
      let route = this.$router.resolve({ 
                  name: 'terms',
                  })
      window.open(route.href, '_blank')
    },
    submit() {
      let order_id = this.$store.getters.orderId
      let customer_id = this.$store.getters.customer.id
      window.open(GeneralVariables.BACKEND+'paypalPayment?order_id='+order_id+"&customer_id="+customer_id,'_blank')
    },
    tokenCreated(token) {},
  }
};
</script>
<style lang="scss" scoped>
.InputElement {
  height: 50px !important;
}

.terms {
  
  @include f-button;
  cursor: pointer;
  text-align: flex-start;
  padding-left: 5px;
  text-decoration: underline !important;
  font-size: 15px;
}

  
  

.price-class{
  @include f-price;
  color: $secondary-color;
  margin-left:10px;
  margin-top:10px;
  margin-right:10px;
}

.fees-class{
  color: $light-black;
  @include f-button;
  text-align: right;
}

.paypal-bottom-info{
    margin-top:10px;
}

@media screen and (max-width:768px) {
  ::v-deep .paypal-submit-class {
    display: block;
    .paypal-submit-btn{
      width: 100% !important;
    }
    .paypal-bottom-info{
      width: 100% !important;
    }
    

  }
}

</style>